import React from 'react';
import Strings from '../common/Strings';
import '../components/Common.css';

const moment = require('moment');

export function getSidePanelDateSectionForWorkLog(
  workLog,
  index,
  workLogArray,
) {
  const today = moment().startOf('day');
  const yesterday = today.clone().subtract(1, 'day');

  const getSection = (w, idx, array) => {
    if (
      idx === 0 ||
      (idx > 0 &&
        !moment(w.createdAt)
          .startOf('day')
          .isSame(moment(array[idx - 1].createdAt).startOf('day')))
    ) {
      const date = moment(w.createdAt);
      if (today.isSame(date, 'day')) {
        return (
          <p className="common-side-panel-day-section">
            {Strings.COMMON.today}
          </p>
        );
      } else if (yesterday.isSame(date, 'day')) {
        return (
          <p className="common-side-panel-day-section">
            {Strings.COMMON.yesterday}
          </p>
        );
      }
      return (
        <p className="common-side-panel-day-section">
          {date.format('YYYY/MM/DD')}
        </p>
      );
    }
    return null;
  };

  return getSection(workLog, index, workLogArray);
}

export function getSidePanelDateSectionForProjectActivity(
  projectActivity,
  index,
  projectActivityArray,
) {
  const today = moment().startOf('day');
  const yesterday = today.clone().subtract(1, 'day');

  const getSection = (a, idx, array) => {
    if (
      idx === 0 ||
      (idx > 0 &&
        !moment(a.timestamp)
          .startOf('day')
          .isSame(moment(array[idx - 1].timestamp).startOf('day')))
    ) {
      const date = moment(a.timestamp);
      if (today.isSame(date, 'day')) {
        return (
          <p className="common-side-panel-day-section">
            {Strings.COMMON.today}
          </p>
        );
      } else if (yesterday.isSame(date, 'day')) {
        return (
          <p className="common-side-panel-day-section">
            {Strings.COMMON.yesterday}
          </p>
        );
      }
      return (
        <p className="common-side-panel-day-section">
          {date.format('YYYY/MM/DD')}
        </p>
      );
    }
    return null;
  };

  return getSection(projectActivity, index, projectActivityArray);
}

export function getSectionForTeamMemberList(
  teamMember,
  index,
  teamMemberArray,
) {
  const getFirstLetter = t => (t.name || t.email).charAt(0).toUpperCase();

  const getSection = (a, idx, array) => {
    const currentFirstLetter = getFirstLetter(array[idx]);
    const prevFirstLetter = idx > 0 ? getFirstLetter(array[idx - 1]) : '';

    if (currentFirstLetter !== prevFirstLetter) {
      return <p className="common-list-section-large">{currentFirstLetter}</p>;
    }
    return null;
  };

  return getSection(teamMember, index, teamMemberArray);
}



// WEBPACK FOOTER //
// ./src/helpers/ui.js